export const removeDuplicate = (arr: any[], property: string): any[] => {
  const map = new Map<string, any>();

  arr.forEach((item) => {
    if (!item || item[property] === undefined || item[property] === null) {
      return;
    }

    const key = String(item[property]).toLowerCase().trim();

    if (!map.has(key)) {
      map.set(key, item);
    }
  });

  return Array.from(map.values());
};
